import { render, staticRenderFns } from "./SearchFood.vue?vue&type=template&id=775edb3c&scoped=true"
import script from "./SearchFood.vue?vue&type=script&lang=js"
export * from "./SearchFood.vue?vue&type=script&lang=js"
import style0 from "./SearchFood.vue?vue&type=style&index=0&id=775edb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775edb3c",
  null
  
)

export default component.exports